// ============================================
// File: components/ErrorBoundary.jsx
// React Error Boundary to catch runtime errors
// ============================================

import React from 'react';
import Support from './pages/Support';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('ErrorBoundary caught an error:', error);
    console.error('Error Info:', errorInfo);
    
    // Store error details in state
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Optional: Send error to logging service
    // this.logErrorToService(error, errorInfo);
  }

  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  // Optional: Method to send errors to a logging service
  logErrorToService = (error, errorInfo) => {
    // Example: Send to your backend or error tracking service
    // fetch('/api/log-error', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     error: error.toString(),
    //     errorInfo: errorInfo.componentStack,
    //     timestamp: new Date().toISOString()
    //   })
    // }).catch(err => console.error('Failed to log error:', err));
  };

  render() {
    if (this.state.hasError) {
      // Render custom Support page
      return (
        <Support 
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          resetError={this.resetError}
          showBackButton={true}
        />
      );
    }

    // Render children normally when there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;